(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bie-apres-hero"]) return;
  try {
    
function setupApresVideos(root=document){
 root.querySelectorAll('.bie-apres-hero').forEach(hero=>{
  if(hero.dataset.ready)return;
  hero.dataset.ready='true';
  const video=hero.querySelector('video'),button=hero.querySelector('.bie-apres-hero__pause');
  if(!video||!button)return;
  const sync=()=>{button.textContent=video.paused?'▶':'Ⅱ';button.setAttribute('aria-label',video.paused?button.dataset.play:button.dataset.pause)};
  video.addEventListener('play',sync);video.addEventListener('pause',sync);
  video.muted=false;
  video.volume=1;
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){video.autoplay=false;video.pause()}
  else{video.play().catch(sync)}
  button.addEventListener('click',()=>{if(video.paused){video.muted=false;video.play().catch(sync)}else{video.pause()}});
  sync();
 });
}
setupApresVideos();
document.addEventListener('shopify:section:load',event=>setupApresVideos(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bie-apres-product"]) return;
  try {
    

function bieSaleInstant(date,time){
 if(!/^\d{4}-\d{2}-\d{2}$/.test(date)||!/^\d{2}:\d{2}$/.test(time))return NaN;
 const desired=Date.parse(date+'T'+time+':00Z');
 if(!Number.isFinite(desired))return NaN;
 const format=new Intl.DateTimeFormat('en-CA',{timeZone:'America/Toronto',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});
 let instant=desired;
 for(let i=0;i<4;i++){
  const p=Object.fromEntries(format.formatToParts(new Date(instant)).map(x=>[x.type,x.value]));
  const represented=Date.parse(p.year+'-'+p.month+'-'+p.day+'T'+p.hour+':'+p.minute+':'+p.second+'Z');
  const delta=desired-represented;
  if(delta===0)return instant;
  instant+=delta;
 }
 return NaN;
}
function bieSetupSale(root=document){
 root.querySelectorAll('.bie-apres-product[data-sale-scheduled]').forEach(section=>{
  if(section.dataset.saleReady)return;
  section.dataset.saleReady='true';
  if(section.dataset.saleScheduled!=='true'){section.removeAttribute('data-sale-pending');return}
  const opens=bieSaleInstant(section.dataset.saleDate,section.dataset.saleTime);
  if(!Number.isFinite(opens))return;
  function update(){
   if(!section.isConnected)return;
   const remaining=opens-Date.now();
   section.toggleAttribute('data-sale-pending',remaining>0);
   if(remaining>0)setTimeout(update,Math.min(remaining,1000));
  }
  update();
 });
}
bieSetupSale();
document.addEventListener('shopify:section:load',event=>bieSetupSale(event.target));



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
